export default __webpack_public_path__ + "static/media/high-res-logo-p-500.66c7e6c6.webp";